import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import * as actions from './common.action';

import { CommonService } from './common.service';

@Injectable()
export class CommonEffect {
    constructor(
        private actions$: Actions,
        private commonService: CommonService,
    ) { }

    getPostList$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_POST_LIST),
        map((action: actions.GetPostListAction) => action.payload),
        switchMap(state => {
            return this.commonService.getPostList(state).pipe(
                map(data => new actions.GetPostListSuccessAction(data)),
                catchError(err => of(new actions.GetPostListFailAction(err)))
            );
        })
    ));

    getPostItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_POST_ITEM),
        map((action: actions.GetPostItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            return this.commonService.getPostItem(id).pipe(
                map(data => new actions.GetPostItemSuccessAction(data)),
                catchError(err => of(new actions.GetPostItemFailAction(err)))
            );
        })
    ));
    removePostItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.REMOVE_POST_ITEM),
        map((action: actions.RemovePostItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            console.log(id, '>>');
            return this.commonService.removePostItem(id).pipe(
                map(data => new actions.RemovePostItemSuccessAction(data)),
                catchError(err => of(new actions.RemovePostItemFailAction(err)))
            );
        })
    ));
    createPostItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.CREATE_POST_ITEM),
        map((action: actions.CreatePostItemAction) => action.payload),
        switchMap(state => {
            return this.commonService.createPostItem(state).pipe(
                map(data => new actions.CreatePostItemSuccessAction(data)),
                catchError(err => of(new actions.CreatePostItemFailAction(err)))
            );
        })
    ));
    updatePOstItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.UPDATE_POST_ITEM),
        map((action: actions.UpdatePostItemAction) => action.payload),
        switchMap(state => {
            return this.commonService.updatePostItem(state).pipe(
                map(data => new actions.UpdatePostItemSucccessAction(data)),
                catchError(err => of(new actions.UpdatePostItemFailAction(err)))
            );
        })
    ));

    getCategoryItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_CATEGORY_ITEM),
        map((action: actions.GetCategoryItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            return this.commonService.getCategoryItem(id).pipe(
                map(data => new actions.GetCategoryItemSuccessAction(data)),
                catchError(err => of(new actions.GetCategoryItemFailAction(err)))
            );
        })
    ));

    getCategoryList$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_CATEGORY_LIST),
        map((action: actions.GetCategoryListAction) => action.payload),
        switchMap(state => {
            return this.commonService.getCategoryList(state).pipe(
                map(data => new actions.GetCategoryListSuccessAction(data)),
                catchError(err => of(new actions.GetCategoryListFailAction(err)))
            );
        })
    ));


    createTagItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.CREATE_TAG_ITEM),
        map((action: actions.CreateTagItemAction) => action.payload),
        switchMap(state => {
            return this.commonService.createTagItem(state).pipe(
                map(data => new actions.CreateTagItemSuccessAction(data)),
                catchError(err => of(new actions.CreateTagItemFailAction(err)))
            );
        })
    ));
    updateTagItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.UPDATE_TAG_ITEM),
        map((action: actions.UpdateTagItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            const params = state.params;
            return this.commonService.updateTagItem(id, state).pipe(
                map(data => new actions.UpdateTagItemSuccessAction(data)),
                catchError(err => of(new actions.UpdateTagItemFailAction(err)))
            );
        })
    ));
    removeTagItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.REMOVE_TAG_ITEM),
        map((action: actions.RemoveTagItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            return this.commonService.removeTagItem(id).pipe(
                map(data => new actions.RemoveTagItemSuccessAction(data)),
                catchError(err => of(new actions.RemoveTagItemFailAction(err)))
            );
        })
    ));
    getTagItem$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_TAG_ITEM),
        map((action: actions.GetTagItemAction) => action.payload),
        switchMap(state => {
            const id = state.id;
            return this.commonService.getTagItem(id).pipe(
                map(data => new actions.GetTagItemSuccessAction(data)),
                catchError(err => of(new actions.GetTagItemFailAction(err)))
            );
        })
    ));
    getTagList$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.GET_TAG_LIST),
        map((action: actions.GetTagListAction) => action.payload),
        switchMap(state => {
            return this.commonService.getTagList(state).pipe(
                map(data => new actions.GetTagListSuccessAction(data)),
                catchError(err => of(new actions.GetTagListFailAction(err)))
            );
        })
    ));

    RemoveImageFromPostAction$ = createEffect(() => this.actions$.pipe(
        ofType(actions.ActionTypes.REMOVE_IMAGE_FROM_POST),
        map((action: actions.RemoveImageFromPostAction) => action.payload),
        switchMap(state => {
            return this.commonService.removeImageFromPost(state).pipe(
                map(data => new actions.RemoveImageFromPostSuccessAction(data)),
                catchError(err => of(new actions.RemoveImageFromPostFailAction(err)))
            );
        })
    ));
}


